import './lib/translateDomGuard'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { theme } from './theme'
import WebApp from './WebApp'
import { initSentry } from './sentry'
import { captureFirstTouch } from './lib/acquisition'
import './styles/tokens.css'
import './styles/marketing.css'
import './styles/docs.css'

initSentry()
captureFirstTouch()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme} defaultMode="system" modeStorageKey="recall.theme">
      <CssBaseline />
      <WebApp />
    </ThemeProvider>
  </StrictMode>,
)
